import { render } from "./Forbidden.vue?vue&type=template&id=91b92d12&scoped=true"
import script from "./Forbidden.vue?vue&type=script&lang=js"
export * from "./Forbidden.vue?vue&type=script&lang=js"

import "./Forbidden.vue?vue&type=style&index=0&id=91b92d12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91b92d12"]])

export default __exports__